import {CoreModel} from '../../model/CoreModel';
import CoreMessageDispatcher from '../../controller/CoreMessageDispatcher';
import SoundEvents from '../../events/SoundEvents';

// doThat = true: do not need an approvement parameter by default

const SetCoverAlmostIn = (doThat = true) => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        const model = CoreModel.instance();
        model.transition3dState = 'in';

        if (model.soundChannelStateChanged) {
            model.resetSoundChannelStateChanged();
            CoreMessageDispatcher.instance().emit(SoundEvents.CHANNEL_STATE_CHANGED);
        }

        resolve(doThat);
    });
};

export {SetCoverAlmostIn};
